var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.58333 6.45455c0-1.78274 1.46811-3.20455 3.25-3.20455h11.66667c1.7819 0 3.25 1.42181 3.25 3.20455v6.54545c0 1.7827-1.4681 3.2045-3.25 3.2045h-.0833v.8864c0 1.7827-1.4681 3.2046-3.25 3.2046h-5.6289l-3.99046 2.3507c-.23188.1366-.51917.1385-.75282.005-.23366-.1336-.37785-.3821-.37785-.6512v-1.7045h-.91667c-1.78189 0-3.25-1.4219-3.25-3.2046v-6.5454c0-1.78278 1.46811-3.20459 3.25-3.20459h.08333zm1.5.88636h10.08337c1.7819 0 3.25 1.42181 3.25 3.20459v4.159h.0833c.9795 0 1.75-.776 1.75-1.7045v-6.54545c0-.92848-.7705-1.70455-1.75-1.70455h-11.66667c-.97953 0-1.75.77607-1.75 1.70455zm-1.58333 1.5c-.97953 0-1.75.77606-1.75 1.70459v6.5454c0 .9285.77047 1.7046 1.75 1.7046h1.66667c.41421 0 .75.3357.75.75v1.1422l3.03599-1.7885c.11534-.0679.24684-.1037.38064-.1037h5.8334c.9795 0 1.75-.7761 1.75-1.7046v-6.5454c0-.92853-.7705-1.70459-1.75-1.70459zm.91667 3.34089c0-.4142.33578-.75.75-.75h4.86113c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-4.86113c-.41422 0-.75-.3358-.75-.75zm0 2.8636c0-.4142.33578-.75.75-.75h8.33333c.4142 0 .75.3358.75.75 0 .4143-.3358.75-.75.75h-8.33333c-.41422 0-.75-.3357-.75-.75z",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat5);
export default __webpack_public_path__ + "static/media/chat5.3a595c21d02fad1abe029b52c0dc6456.svg";
export { ForwardRef as ReactComponent };